import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ForwardArrowIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.645105 1.3522C0.450593 1.15619 0.451807 0.839607 0.647816 0.645094C0.843824 0.450582 1.16041 0.451795 1.35492 0.647804L11.1764 10.5449C11.1772 10.5456 11.1779 10.5464 11.1786 10.5471C11.1788 10.5473 11.179 10.5474 11.1791 10.5476C11.3493 10.7191 11.3697 10.9829 11.2408 11.1765C11.2229 11.2033 11.2022 11.2288 11.1786 11.2525C11.1779 11.2532 11.1772 11.254 11.1764 11.2547L1.35492 21.1518C1.16041 21.3478 0.843824 21.349 0.647816 21.1545C0.451807 20.96 0.450593 20.6434 0.645105 20.4474L10.1198 10.8998L0.645105 1.3522Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default ForwardArrowIcon;

ForwardArrowIcon.propTypes = customIconsPropTypes;
